export const environment = {
  production: true,
  URL_BASE_APP_USUARIOS: 'https://appusuario.sicoralarmas.com:8085',
  URL_HOST: 'https://appsat.sicoralarmas.com:3001/v1/api/ping/',
  URL_DEEPLINK: "areaclientes.sicoralarmas.com/app",
  USER_MANUAL_AJAX: "https://areaclientes.sicoralarmas.com/files/Ajax.pdf",
  USER_MANUAL_HIK: "https://areaclientes.sicoralarmas.com/files/Hikvision.pdf",
  MANUAL_APP: "https://areaclientes.sicoralarmas.com/files/App.pdf",
  ENVIRONMENT_SELECTED: "P",
  APP_VERSION: "1.3.3.173",
  END_POINT_SBN: 'https://appusuario.sicoralarmas.com:8085',
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyC9PxG-jsqMU2MQMLCPOIsKpt23PeFYQTk",
    authDomain: "sicor-pro.firebaseapp.com",
    projectId: "sicor-pro",
    storageBucket: "sicor-pro.appspot.com",
    messagingSenderId: "237156175874",
    appId: "1:237156175874:web:b22d4c5a5c18a767c2571b",
    measurementId: "G-2K9XNVD6QK"
  },
  KEY_CRYPTO: 'Sicor2022.',
  VAELSYS_CONFIG: {
    apiUrl: 'https://vs.sicoralarmas.com/sbn/api/sbn',
    wsUrl: 'wss://vs.sicoralarmas.com/ws/',
    wsRealm: 'default_realm',
    iceServers: [
      {
        url: 'turn:vswebrtc.sicoralarmas.com:3478?transport=udp'
      },
      {
        url: 'turn:vswebrtc.sicoralarmas.com:3478?transport=tcp'
      }
    ]
  },
  RECAPTCHA_V3_KEY: '6LefE2QqAAAAAKRxAVqmp-erSukhwzX3F3XqWlz1'
};
